<script setup lang="ts">
    import { ref, computed, watch } from 'vue'

    /* ---------------- props / emits ---------------- */

    const props = defineProps<{
        propOpened: boolean
        propDefaultSurveyId?: number | null
        propDefaultProjectUserId?: number | null
        propSurveys: { Id: number; Name: string }[]
        propProjectUsers: { Id: number; Name: string }[]
    }>()

    const emit = defineEmits<{
        (e: 'load-panelists', surveyId: number): void
        (e: 'confirm-selection', surveyId: number | null, projectUserId: number | null): void
        (e: 'close-dialog'): void
    }>()

    /* ---------------- derived props ---------------- */

    const opened = computed(() => props.propOpened)
    const defaultSurveyId = computed<number | null>(() => props.propDefaultSurveyId ?? null)
    const defaultProjectUserId = computed<number | null>(() => props.propDefaultProjectUserId ?? null)

    const surveys = computed(() => props.propSurveys)
    const projectUsers = computed(() => props.propProjectUsers)

    /* ---------------- local state ---------------- */

    const surveyId = ref<number | null>(null)
    const projectUserId = ref<number | null>(null)

    /* ---------------- watchers ---------------- */

    // replaces @Watch('opened')
    watch(opened, (val) =>
    {
        if (val === true)
        {
            surveyId.value = defaultSurveyId.value
            projectUserId.value = defaultProjectUserId.value
        }
    })

    // replaces @Watch('surveyId')
    watch(surveyId, (val) =>
    {
        if (val != null)
        {
            projectUserId.value = null
            emit('load-panelists', val)
        }
    })

    /* ---------------- actions ---------------- */

    function confirm()
    {
        emit('confirm-selection', surveyId.value, projectUserId.value)
    }

    function close()
    {
        emit('close-dialog')
    }
</script>


<template>
    <div class="modal-mask" v-if="opened === true">
        <div class="modal-wrapper">
            <div class="modal-dialog modal-dialog-scrollable">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Evaluation</h5>
                        <button @click="close" type="button" class="close">&times;</button>
                    </div>
                    <div class="modal-body">
                        <div class="form-group">
                            <label>Panel:</label>
                            <select v-model="surveyId" class="form-control">
                                <option v-for="s in surveys" :value="s.Id">{{s.Name}}</option>
                            </select>
                        </div>

                        <div class="form-group">
                            <label>Respondent:</label>
                            <select v-model="projectUserId" class="form-control">
                                <option :value="null">Aggregated</option>
                                <option v-for="p in projectUsers" :value="p.Id">{{p.Name}}</option>
                            </select>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" @click="close" class="btn btn-outline-secondary">Close</button>
                        <button type="button" @click="confirm" class="btn btn-success">Confirm</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template> 